<template>
  <div class="c-o-request-section c-o-request-section--information">
    <modal class="c-m-modal--small" v-if="contractConfirmation" @close="this.close">
      <p>Är du säker på att du vill använda {{selectedContract !== 1 ? 'Hantverkarformuläret 17' : 'Entreprenadkontrakt ABS 18'}}</p>

      <button-group class="c-m-button-group--margin-top">
        <atom-button label="Tillbaka" class="c-a-button--theme-white" @buttonClicked="this.close" />
        <atom-button
          label="Ja, öppna avtalsmall"
          class="c-a-button--theme-primary"
          @buttonClicked="this.submit"
        ></atom-button>
      </button-group>
    </modal>

    <div class="c-o-request-section__inner">
      <div class="c-o-request-section__main u-padding-3 box">
        <loader class="c-m-loader c-m-loader--overlay" v-if="isLoading && !error" key="loading" />
        <error-state v-bind="errorStateContent" hideIcon v-else-if="!isLoading && error" />

        <div v-if="!contractExist">
          <atom-title :icon="'info'">Beställaren önskar få ett avtalsförslag från ert företag</atom-title>
          <p>Grattis! Beställaren har valt att gå vidare med ert företag. Välj vilken avtalsmall som passar bäst för just detta projekt.</p>
          <ul>
            <li>
              <span class="contractTypeHighlight">Entreprenadkontrakt</span>- Används endast vid uppförande eller tillbyggnad av en- eller tvåbostadshus.
            </li>
            <li>
              <span class="contractTypeHighlight">Hantverkarformuläret</span> - Användas för alla andra projekt.
            </li>
          </ul>

          <p>Mallen kommer öppnas upp som en redigerbar PDF-fil som du fyller i. Du skriver sedan under avtalet med BankID och avtalet skickas direkt till beställarens mailadress för signering.</p>

          <div>
            <b>Välj Avtal:</b>
          </div>
          <atom-button
            :class="'c-a-button--theme-primary u-margin-top-2'"
            :label="'Hantverkarformuläret'"
            @buttonClicked="() => {
                selectedContract = contractTypes.standardContract
                contractConfirmation = true
                
                }"
          />

          <atom-button
            :class="'c-a-button--theme-primary u-margin-top-2'"
            :label="'Entreprenadkontrakt ABS 18'"
            @buttonClicked="() => {
                selectedContract = contractTypes.abs18
                contractConfirmation = true
                
                }"
          />
        </div>

        <div v-else>
          <atom-title :icon="contractInfo.icon">{{contractInfo.headerString}}</atom-title>
          <p>{{contractInfo.content}}</p>
          <atom-button
            v-if="contractUrl"
            :class="'c-a-button--theme-secondary-light c-a-button--hollow-thin u-margin-top-2'"
            :label="btnText"
            :icon="'file'"
            @buttonClicked="openContract"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
  CREATE_CONTRACT,
  GET_EDIT_CONTRACT_LINK,
  GET_CASE,
  IS_LOADING,
  GET_ERROR,
  GET_CONTRACT_URL,
  GET_CONTRACT_TYPES
} from "../../../../store/store-models/contract-model";
import Modal from "../../molecules/MoleculeModal";
import AtomButton from "../../atoms/AtomButton.vue";
import AtomButtonLinkExternal from "../../atoms/AtomButtonLinkExternal.vue";
import Loader from "../../molecules/MoleculeLoader.vue";
import ErrorState from "../../molecules/MoleculeErrorState.vue";
import AtomTitle from "../../atoms/AtomTitle.vue";
import ButtonGroup from "../../molecules/MoleculeButtonGroup";

export default {
  components: {
    Loader,
    ErrorState,
    AtomButton,
    AtomButtonLinkExternal,
    AtomTitle,
    Modal,
    ButtonGroup
  },
  props: ["contract"],
  data() {
    return {
      contractConfirmation: false,
      selectedContract: null
    };
  },
  computed: {
    ...mapGetters({
      case: GET_CASE,
      isLoading: IS_LOADING,
      error: GET_ERROR,
      contractUrl: GET_CONTRACT_URL,
      contractTypes: GET_CONTRACT_TYPES
    }),
    contractInfo() {
      const data = {
        icon: "",
        headerString: "",
        content: ""
      };
      if (this.contract.IsSignedByAllParties) {
        data.icon = "check_circle";
        data.headerString = "Avtal signerat!";
        data.content =
          "Här finns en kopia av ert signerade avtal. Kopian av avtalet lagras hos BraByggare och vi rekommenderar även att ni sparar en egen kopia. Gå in på avtalet och klicka på “Ladda ned” högst upp. ";
      } 
      else if (this.contract.version > 1 && !this.contract.isSent) {
        data.icon = "info";
        data.headerString = "Beställare inväntar förändringar från er";
        
      } else if (this.contract.isDraft) {
        data.icon = "info";
        data.headerString = "Avtal inväntar redigering";
        data.content =
          "Avtalsförslaget har skapats, redigera inehållet och skicka det till beställaren";
        
      }      
      else if (!this.contract.isSent){
        data.icon = "info";
        data.headerString = "Signera avtalet för att skicka det till Beställaren";
        data.content = "För att skicka avtalet till beställaren gå till avtalet och signera";
      } else {
        data.icon = "info";
        data.headerString = "Inväntar signering från beställaren";
        data.content =
          "Avtalsförslaget har skickats till beställaren och du blir meddelad via mail när beställaren signerat. Skulle beställaren vilja revidera något i avtalet får du även meddelande om det.";
      }

      return data;
    },
    btnText() {
      return !this.contract.isDraft
        ? "Visa avtal"
        : "Redigera avtal";
    },
    assentlyContract() {
      return this.case;
    },
    contractExist() {
      return this.contractUrl != null;
    },
    errorStateContent: function() {
      let content = {
        heading: 'Sidan kunde inte hittas',
        body: '<p>Länken till sidan du försöker hämta fungerar inte.</p>',
      };

      if (this.error.status === 404) {
        content = {
          ...content,
          heading: "Förfrågan kunde inte hittas",
          body:
            '<p>Den kan ha raderats eller så kan länken du följde vara felaktig.</p><p>Om problemet kvarstår kan du kontakta kundtjänst på <a href="mailto:info@brabyggare.se">info@brabyggare.se</a></p>'
        };
      }

      return content;
    }
  },
  methods: {
    ...mapActions({
      createContract: CREATE_CONTRACT,
      getEditContractLink: GET_EDIT_CONTRACT_LINK
    }),
    async submit() {
      this.contractConfirmation = false;
      let res = await this.createContract(this.selectedContract);
      window.location = this.contractUrl;
    },
    redirect() {
      let redirect = window.open("", "_blank");
      this.getEditContractLink().then(link => {
        redirect.location = this.contractUrl;
      });
    },
    openContract() {
      window.open(this.contractUrl);
    },
    close() {
      this.selectedContract = null;
      this.contractConfirmation = false;
    }
  }
};
</script>

<style scoped>
.box {
  background: #fafafa;
  border: 1px solid #e6e6e6;
  box-sizing: border-box;
  position: relative;
  max-width: 1024px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}
.box >>> h3 {
  margin-top: 0;
  margin-bottom: 1rem;
}

.contractTypeHighlight {
  font-weight: bold;
  font-style: italic;
}
</style>


// WEBPACK FOOTER //
// src/views/components/organisms/request-sections/OrganismContract.vue